// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import 'element-ui/lib/theme-chalk/display.css'
import RootView from './views/root.view'
import router from './router/router'
import store from './store/store'
import './config'
import filter from '@/filters/index'

// DEPENDENCIES
import vueScrollto from 'vue-scrollto'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import SocialSharing from 'vue-social-sharing'
import VueCarousel from 'vue-carousel'
import moment from 'moment'

Vue.use(SocialSharing)
Vue.use(VueCarousel)
Vue.use(filter)
Vue.use(vueScrollto)
Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper /* { default global options } */)
Vue.config.keyCodes.enter = 13
moment.locale('es')

/* eslint-disable no-new */
new Vue({
  el: '#root',
  router,
  store,
  components: { RootView },
  template: '<root-view/>'
})



// WEBPACK FOOTER //
// ./src/main.js